import { render } from "./EditMap.vue?vue&type=template&id=f3828920"
import script from "./EditMap.vue?vue&type=script&lang=js"
export * from "./EditMap.vue?vue&type=script&lang=js"

import "./EditMap.vue?vue&type=style&index=0&id=f3828920&lang=scss"
script.render = render

export default script